import React from "react";
import { TestCards } from "../TestCards/TestCards";

function Selection() {
    return (
        <TestCards/>
    )
}

export { Selection };
